import './main.css';
import {createApp} from "vue/dist/vue.esm-bundler";
import {AisAutocomplete, AisInstantSearch, AisSearchBox} from 'vue-instantsearch/vue3/es';
import algoliasearch from 'algoliasearch/lite';
import {
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Switch,
  SwitchGroup,
  SwitchLabel
} from '@headlessui/vue'

const algoliaClient = algoliasearch(
    process.env.MIX_ALGOLIA_APPLICATION_ID,
    process.env.MIX_ALGOLIA_SEARCH_ONLY_API_KEY
);

const App = {
    components: {
        Popover,
        PopoverButton,
        PopoverGroup,
        PopoverPanel,
        Listbox,
        ListboxButton,
        ListboxOptions,
        ListboxOption,
        AisInstantSearch,
        AisSearchBox,
        AisAutocomplete,
        'switch-input': Switch, //Needs a rename for not producing a v-model can only be used on...... warning
        SwitchGroup,
        SwitchLabel
    },
    data() {
        return {
            contactForm: {
                name: null,
                email: null,
                phone: null,
                description: null,
                success: false,
                error: false
            },
            priceCalculator: {
              noOfTickets: null,
              ticketPrice: null,
              feeExcludedInPrice: true
            },
            priceCalculatorResults: {
                totalEarnings: this.formatForCurrency(0),
                ticketPrice:  this.formatForCurrency(0),
                ticketFee:  this.formatForCurrency(0),
                buyerTotal:  this.formatForCurrency(0)
            },
            searchClient: {
                ...algoliaClient,
                search(requests){
                    if (requests.every(({ params }) => params.query.length < 3)) {
                        return Promise.resolve({
                            results: requests.map(() => ({
                                hits: [],
                                nbHits: 0,
                                nbPages: 0,
                                page: 0,
                                processingTimeMS: 0,
                            })),
                        });
                    }
                    return algoliaClient.search(requests);
                }
            },
        };
    },
    watch: {
        priceCalculator: {
            handler: function(){
                this.calculateTicketPrice();
            },
            deep: true,
            immediate: false
        }
    },
    methods: {
        formatForCurrency(number){
            return new Intl.NumberFormat("da", {
                style: "currency",
                currency: 'DKK'
            }).format(number / 100);
        },
        allowedForNumberInput: function(evt) {
            const acceptedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Enter', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
            const keyPressed = evt.key;

            if (!acceptedKeys.includes(keyPressed)) {
                evt.preventDefault()
            }
        },
        calculateTicketPrice(){
            let ticketPrice = this.priceCalculator.ticketPrice;
            let totalEarnings = 0;
            let buyerTotal = 0;
            let ticketFee = 0;
            const noOfTickets = Number.parseInt(this.priceCalculator.noOfTickets) || 1;
            let data = new FormData();
            data.append("price", ticketPrice*100);
            fetch("https://manage.tickethero.dk/api/ticket/calculate-fee", {
                method: 'POST',
                body: data
            })
              .then((response) => response.json())
              .then((response) => {
                  ticketFee = response.fee;
                  ticketPrice = Number.parseInt(response.price);
                  buyerTotal = ticketPrice + (this.priceCalculator.feeExcludedInPrice ? ticketFee : 0);
                  totalEarnings = (noOfTickets * ticketPrice) - (this.priceCalculator.feeExcludedInPrice? 0 : (noOfTickets * ticketFee))
                  this.priceCalculatorResults = {
                      totalEarnings: this.formatForCurrency(totalEarnings),
                      ticketPrice: this.formatForCurrency(ticketPrice),
                      ticketFee: this.formatForCurrency(ticketFee),
                      buyerTotal: this.formatForCurrency(buyerTotal)
                  }
              });

        },
        submitContactForm(e){
            this.contactForm.success = false;
            this.contactForm.error = false;

            let data = new FormData();
            data.append("name", this.contactForm.name);
            data.append("email", this.contactForm.email);
            data.append("phone", this.contactForm.phone);
            data.append("description", this.contactForm.description);

            fetch("/wp-json/tickethero/contact", {
                method: 'POST',
                body: data
            }).then((response) => {
                  this.contactForm.success = true;
                  this.contactForm.name = null;
                  this.contactForm.email = null;
                  this.contactForm.phone = null;
                  this.contactForm.description = null;
            })
              .catch((response) => {
                  this.contactForm.error = true;
            });
        }
    }
}
createApp(App).mount('#app');
